var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKakaoGiftcolorinline = function SvgKakaoGiftcolorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 13.2V8.4A1.201 1.201 0 0012 7.36l-4.2-2.4a1.197 1.197 0 00-1.2 0l-4.2 2.4A1.198 1.198 0 001.8 8.4v4.802a1.201 1.201 0 00.6 1.038l4.2 2.4a1.197 1.197 0 001.2 0l4.2-2.4a1.203 1.203 0 00.6-1.038z",
    stroke: "#000",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.962 7.776l5.238 3.03 5.238-3.03",
    stroke: "#000",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 16.8v-6",
    stroke: "#000",
    strokeWidth: 1.165,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.856 16.393l-4.705-2.638V8.287l4.692 2.725M2.513 7.695l4.69 2.713 4.684-2.72L7.203 5.02l-4.69 2.675z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.312 1.684a1.925 1.925 0 00-2.722 0l-.372.371-.37-.37a1.925 1.925 0 10-2.723 2.722l.37.37 2.723 2.724 2.723-2.723.37-.371a1.925 1.925 0 00.001-2.723z",
    fill: "#DF2C2C",
    stroke: "#000",
    strokeWidth: 1.092,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52 11.045l4.768-2.792.016.289-.014 5.168-4.782 2.716",
    fill: "#F2CF00"
  })));
};

export default SvgKakaoGiftcolorinline;